export const TASK_TABS = {
  MY: 'my',
  ALL: 'all',
} as const

export type TaskTab = (typeof TASK_TABS)[keyof typeof TASK_TABS]

export type TaskStatusType =
  | 'all'
  | 'processing'
  | 'completed'
  | 'failed'
  | 'deleted'
  | 'suspended'

export const PAGINATION_OPTIONS = {
  MY_TASKS_DEFAULT_SIZE: 10,
  ALL_TASKS_DEFAULT_SIZE: 25,
  PAGE_SIZE_OPTIONS: ['10', '25', '50', '100', '500'] as const,
  PAGE_ALL_SIZE_OPTIONS: ['25', '50', '100', '500'] as const,
} as const

export const TaskStatusConfig = {
  Created: { variant: 'created' as const, label: 'В очереди' },
  Successed: { variant: 'done' as const, label: 'Завершена' },
  Started: { variant: 'processed' as const, label: 'В процессе' },
  Failed: { variant: 'danger' as const, label: 'Ошибка' },
  Suspended: { variant: 'attention' as const, label: 'В ожидании' },
  Deleted: { variant: 'deleted' as const, label: 'Удалена' },
} as const

export const STATS_DISPLAY_CONFIG = [
  { key: 'Agents' as const, label: 'Клиенты' },
  { key: 'Vehicles' as const, label: 'Объекты' },
  { key: 'Messages' as const, label: 'Сообщения' },
  { key: 'Drivers' as const, label: 'Водители' },
  { key: 'Users' as const, label: 'Пользователи' },
  { key: 'Geozones' as const, label: 'Геозоны' },
  { key: 'Retranslations' as const, label: 'Ретрансляторы' },
] as const

export const RECONFIGURATION_STATS_DISPLAY_CONFIG = [
  { key: 'DeviceRedirector' as const, label: 'Перенастроено' },
] as const

export type TaskLogType = 'info' | 'warning' | 'error' | 'access'

export type TaskLogFilter = 'all' | 'info' | 'warning' | 'error'
